import Vue from "vue";
import App from "./App";
import router from "./router";
import Croppa from "vue-croppa";
import wcSwiper from "wc-swiper";
import Cube from "cube-ui";
import VueScroller from "vue-scroller";
import ElementUI from "element-ui";
import * as filters from "./filters"; // global filters
import store from "./store";
import "vue-social-share/dist/client.css";
import "vue-croppa/dist/vue-croppa.css";
import "wc-swiper/style.css";
// import 'element-ui/lib/theme-chalk/index.css'
import i18n from "@/common/lang/index";
import VueLazyLoad from "vue-lazyload";
import "@/styles/index.scss";
import FastClick from "fastclick";
import VDistpicker from "v-distpicker";
import "babel-polyfill";
import Emojify from "emojify.js";
import "emojify.js/dist/css/basic/emojify.min.css";
import "./permission"; // permission control
import VConsole from "vconsole";
import "jquery";
import kMessage from "@/common/js/kMessage";

Emojify.setConfig({
  img_dir: "static/img/emoji"
});

Vue.prototype.$emoji = Emojify;
Vue.prototype.$kMessage = kMessage;

Vue.component("v-distpicker", VDistpicker);
require("video.js/dist/video-js.css");
require("vue-video-player/src/custom-theme.css");

FastClick.attach(document.body);
Vue.config.productionTip = false;
Vue.use(Croppa);
Vue.use(wcSwiper);
Vue.use(Cube);
Vue.use(VueScroller);

const hls = require("videojs-contrib-hls");
Vue.use(hls);

// router.beforeEach((to, from, next) => {
//   /* 统计代码 */
//   window._hmt.push(['_trackPageview', to.fullPath])
//   next()
// })
/* 统计代码 */
router.beforeEach((to, from, next) => {
  if (to.path) {
    if (window._hmt) {
      window._hmt.push(["_trackPageview", "/#" + to.fullPath]);
    }
  }
  next();
});
/* 路由发生变化修改页面title */
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
    document
      .querySelector('meta[name="keywords"]')
      .setAttribute(
        "content",
        "软考,软考培训,软考考试认证,软考辅导,软考入门,信息系统项目管理师,软考报名时间,软考考试时间,软考考试科目,软考成绩查询,软考取证"
      );
    document
      .querySelector('meta[name="description"]')
      .setAttribute(
        "content",
        "易极云课堂为您提供软考,软考培训,软考考试认证,软考报名时间,软考考试时间,软考考试科目,软考成绩查询,软考取证等软考培训课程大全,权威专业授课讲师,技术大牛实战分享,通俗易懂,学完即用,解决实战技术难题.\n"
      );
  }

  // 在router中可以配置单个页面的缓存策略
  if (to.meta.cache) {
    if (document.querySelector('meta[http-equiv="Cache-Control"]')) {
      document
        .querySelector('meta[http-equiv="Cache-Control"]')
        .setAttribute("content", to.meta.cache);
    } else {
      let head = document.getElementsByTagName("head");
      if (head) {
        let meta = document.createElement("meta");
        meta.httpEquiv = "Cache-Control";
        meta.content = to.meta.cache;
        head[0].appendChild(meta);
      }
    }
  }

  next();
});

Vue.use(ElementUI, {
  // 选择ui中组件的尺寸
  size: "medium",
  i18n: (key, value) => i18n.t(key, value)
});
Vue.use(VueLazyLoad, {
  // 导入懒加载的图片
  loading: require("@/common/image/cloud.png")
});
// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});
// var vConsole = new VConsole()
/* eslint-disable no-new */
new Vue({
  // 这儿是挂载到index.html的app中
  el: "#app1",
  router,
  i18n,
  store,
  // 注册组件
  components: { App },
  // 将app模板替换挂载的元素，挂载元素的内容将被忽略，除非模板的内容有插槽
  template: "<App/>"
});

FastClick.prototype.focus = function(targetElement) {
  var length; //兼容处理:在iOS7中，有一些元素（如date、datetime、month等）在setSelectionRange会出现TypeError //这是因为这些元素并没有selectionStart和selectionEnd的整型数字属性，所以一旦引用就会报错，因此排除这些属性才使用setSelectionRange方法

  if (
    deviceIsIOS &&
    targetElement.setSelectionRange &&
    targetElement.type.indexOf("date") !== 0 &&
    targetElement.type !== "time" &&
    targetElement.type !== "month" &&
    targetElement.type !== "email"
  ) {
    length = targetElement.value.length;

    targetElement.setSelectionRange(
      length,
      length
    ); /*修复bug ios 11.3不弹出键盘，这里加上聚焦代码，让其强制聚焦弹出键盘*/

    targetElement.focus();
  } else {
    targetElement.focus();
  }
};



// WEBPACK FOOTER //
// ./src/main.js